import { noop } from './ViewletTitleBarMenuBarNoop.js'

export const handleKeyArrowUpMenuClosed = noop
